export default {
  moveNameStyles: {
    margin: "1rem 0 0 0",
  },
};
